import ApostleSVG from '@public/icons/icon-marketplace-apostle.svg'
import GodiverseSVG from '@public/icons/icon-marketplace-godiverse.svg'
import PlanetSVG from '@public/icons/icon-marketplace-planet.svg'
import StarSVG from '@public/icons/icon-marketplace-star.svg'
import OrbitSVG from '@public/icons/icon-orbital-track.svg'
import SharedSecNavBar from '@src/components/navigationBar/secondary/SharedSecNavBar'
import { NAV_BAR_CONFIG } from '@src/constants/layout'
import { ROUTE } from '@src/constants/route'
import { FC } from 'react'

const NAVIGATION_ITEMS = [
  {
    icon: PlanetSVG,
    route: ROUTE.MARKETPLACE_PLANET_LIST,
    translationKey: 'common.planets'
  },
  {
    icon: ApostleSVG,
    route: ROUTE.MARKETPLACE_APOSTLE_LIST,
    translationKey: 'sub_bar.marketplace.apostle'
  },
  {
    icon: StarSVG,
    route: ROUTE.MARKETPLACE_STAR_LIST,
    translationKey: 'sub_bar.marketplace.star'
  },
  {
    icon: GodiverseSVG,
    route: ROUTE.MARKETPLACE_GODIVERSE_LIST,
    translationKey: 'sub_bar.marketplace.godiverse'
  },
  {
    icon: OrbitSVG,
    route: ROUTE.MARKETPLACE_ORBITAL_TRACK_LIST,
    translationKey: 'sub_bar.marketplace.orbiting'
  }
]

const EmporiumSecNavBar: FC<Props> = (props: Props) => {
  const { index = 0 } = props

  return (
    <SharedSecNavBar
      height={NAV_BAR_CONFIG.secondary.height}
      index={index}
      navigationItems={NAVIGATION_ITEMS}
    />
  )
}

type Props = {
  index: number
}

export default EmporiumSecNavBar
